// @owners { team: patients }
import { type ReduxStateShared } from '~shared/types';

export const getSelectedInsuranceID = (state: ReduxStateShared) => state.insurances.selectedInsuranceID;
